export default {
    "abbreviation": {
        "appointment": "RDV",
        "cloudflare": "CF",
        "hour": "h",
        "hourly": "H",
        "onceAMonth": "1X/MOIS",
        "onceAWeek": "1X/SEM",
        "onceAYear": "1X/AN",
        "package": "F",
        "project": "P",
        "recurrent": "REC",
        "shoppingfeed": "SF",
        "twiceAYear": "2X/AN"
    },
    "button": {
        "add": "Ajouter",
        "addCustomer": "Ajouter un client",
        "addSubTask": "Ajouter une sous-tâche",
        "addTime": "Ajouter du temps",
        "apply": "Appliquer",
        "back": "Retour",
        "cancel": "Annuler",
        "chat": "Chat",
        "clear": "Effacer",
        "closeTask": "Fermer la tâche",
        "collapse": "Réduire",
        "configure": "Configurer",
        "connectBusinessDropboxAccount": "Connecter un compte Dropbox Business",
        "connectIndividualDropboxAccount": "Connecter un compte Dropbox individuel",
        "convertToTask": "Convertir en tâche",
        "create": "Créer",
        "createLink": "Créer un lien",
        "csv": "CSV",
        "delete": "Supprimer",
        "deleteLink": "Supprimer le lien",
        "downloadFileExample": "Télécharger un exemple de fichier",
        "eCommerce": "E-commerce",
        "edit": "Modifier",
        "editContent": "Modifier le contenu",
        "editCustomer": "Modifier le client",
        "editCustomerModules": "Modifier les modules du client",
        "editServer": "Modifier le serveur",
        "editUser": "Modifier l'utilisateur",
        "enable": "Activer",
        "enableModule": "Activer un module",
        "expand": "Développer",
        "export": "Exporter",
        "exportCustomers": "Exporter les clients",
        "forceIndexation": "Forcer l'indexation",
        "forceSynchronization": "Forcer la synchronisation",
        "generateActOfPurchase": "Générer l'acte d'achat",
        "generateCSVProductImportFile": "Générer le fichier produit à importer",
        "generateLastReport": "Générer le dernier rapport",
        "hasToCall": "Doit être relancé",
        "hasToTakeStock": "Prendre un RDV",
        "import": "Importer",
        "invalidateCustomerTask": "Invalider la tâche client",
        "loading": "Chargement...",
        "login": "Connexion",
        "loginWithGoogle": "Se connecter avec Google",
        "mailRequestSentAt": "Mail demande RDV envoyé",
        "notHasToCall": "Ne doit pas être relancé",
        "notHasToTakeStock": "Ne pas prendre de RDV",
        "openDropboxChooser": "Ouvrir le sélecteur Dropbox",
        "openFolderSelector": "Ouvrir le sélecteur de dossier",
        "pause": "Pause",
        "pend": "Mettre en attente",
        "prefill": "Préremplir",
        "preview": "Prévisualiser",
        "previewLatestReportGenerated": "Prévisualiser le dernier rapport généré",
        "process": "Traiter",
        "processAlert": "Traiter l'alerte",
        "processTask": "Traiter la tâche",
        "refresh": "Actualiser",
        "refreshProductData": "Actualiser les données produit",
        "refreshProductVariationData": "Actualiser les données de variation de produit",
        "remove": "Retirer",
        "resetPassword": "Réinitialiser le mot de passe",
        "resume": "Reprendre",
        "returnToIndex": "Retour à l'accueil",
        "save": "Enregistrer",
        "saveAdditionalInformation": "Enregistrer les informations complémentaires",
        "saveInProgress": "Enregistrement en cours...",
        "see": "Voir",
        "seeAdditionalInformation": "Voir les informations complémentaires",
        "seeAnswer": "Voir la réponse",
        "seeApikomContent": "Voir le suivi des contenus Apikom",
        "seeBackup": "Voir la backup",
        "seeBudgetNotes": "Voir les notes de budget",
        "seeComment": "Voir le commentaire",
        "seeCustomerComment": "Voir le commentaire client",
        "seeCustomers": "Voir les client",
        "seeData": "Voir les données",
        "seeDescription": "Voir la description",
        "seeDescriptionAndRequirements": "Voir la description et les besoins",
        "seeDetails": "Voir les détails",
        "seeEmailing": "Voir l'emailing",
        "seeExternalServices": "Voir les services externes",
        "seeGoogleAdsTracking": "Voir le suivi du Google Ads",
        "seeIndexationTracking": "Voir le suivi d'indexation",
        "seeInternalComment": "Voir le commentaire interne",
        "seeInternalMesh": "Voir le suivi du maillage interne",
        "seeInternalNotes": "Voir les notes internes",
        "seeIpBlock": "Voir le bloc IP",
        "seeMessage": "Voir le message",
        "seeModules": "Voir les modules",
        "seeMyTasks": "Voir mes tâches",
        "seeNetlinkingTracking": "Voir le suivi du netlinking",
        "seeNotes": "Voir les notes",
        "seePageSpeedTracking": "Voir le suivi du temps de chargement",
        "seePositionTracking": "Voir le suivi des positions",
        "seeProducts": "Voir les produits",
        "seeQuotationLink": "Voir le lien du devis",
        "seeRequirements": "Voir les besoins",
        "seeSignedQuotationLink": "Voir le lien du devis signé",
        "seeSms": "Voir le SMS",
        "seeStrategy": "Voir la stratégie",
        "send": "Envoyer",
        "sendEmail": "Envoyer un email",
        "sending": "Envoi en cours...",
        "sendLastReport": "Envoyer le dernier rapport",
        "showcase": "Vitrine",
        "showOnGameCash": "GameCash",
        "synchronize": "Synchroniser",
        "unprocess": "Détraiter",
        "unprocessAlert": "Détraiter l'alerte",
        "updateAppointmentFrequency": "Mettre à jour la fréquence des RDV",
        "updateData": "Mettre à jour les données",
        "validateCustomerTask": "Valider la tâche client",
        "xlsx": "XLSX"
    },
    "error": {
        "atLeastOneTargetRequired": "Au moins une cible est requise.",
        "dropboxMustBeConnected": "Vous devez connecter Dropbox pour pouvoir utiliser cette fonctionnalité.",
        "email": "Veuillez saisir une adresse email valide.",
        "failedToLoadKeywordPositionHistory": "Impossible de charger l'historique des positions du mot clé.",
        "formHasErrors": "Le formulaire contient des erreurs.",
        "noPaymentMethodSelected": "Aucun moyen de paiement sélectionné.",
        "noProductSelected": "Aucun produit sélectionné.",
        "noSupplierSelected": "Aucun fournisseur sélectionné.",
        "number": "Veuillez saisir un nombre.",
        "passwordConfirmation": "Les mots de passe ne correspondent pas.",
        "required": "Ce champ est obligatoire.",
        "url": "Veuillez saisir une URL valide."
    },
    "label": {
        "cartCompletionRate": "Taux de réalisation panier",
        "cartAbandonmentRate": "Taux d'abandon panier",
        "isTracked": "Est suivi",
        "keywordAdded": "Mot-clé ajouté",
        "keywords": "Mots-clés",
        "lastUpdate": "Dernière MAJ",
        "activeFollowUp": "Suivi actif",
        "daily": "Journalier",
        "carts": "Paniers",
        "comparisonCarts": "Paniers de comparaison",
        "cartConversionRate": "Taux de conversion panier",
        "comparisonCartConversionRate": "Taux de conversion panier de comparaison",
        "comparisonBetween": "Comparaison entre",
        "last30Days": "30 derniers jours",
        "lastYear": "L'année dernière",
        "2YearsAgo": "Il y a 2 ans",
        "turnoverIncludingTaxLast30Days": "CA TTC J-30",
        "turnoverIncludingTaxLastYear": "CA TTC A-1",
        "turnoverIncludingTaxLast2Years": "CA TTC A-2",
        "seaCostsLast30Days": "Coûts SEA J-30",
        "seaCostsLastYear": "Coûts SEA A-1",
        "seaCostsLast2Years": "Coûts SEA A-2",
        "smaCostsLast30Days": "Coûts SMA J-30",
        "smaCostsLastYear": "Coûts SMA A-1",
        "smaCostsLast2Years": "Coûts SMA A-2",
        "adCostsToTurnoverRatioLast30Days": "Dépenses pub % CA J-30",
        "adCostsToTurnoverRatioLastYear": "Dépenses pub % CA A-1",
        "adCostsToTurnoverRatioLast2Years": "Dépenses pub % CA A-2",
        "seaRoasLast30Days": "ROAS SEA J-30",
        "seaRoasLastYear": "ROAS SEA A-1",
        "seaRoasLast2Years": "ROAS SEA A-2",
        "smaRoasLast30Days": "ROAS SMA J-30",
        "smaRoasLastYear": "ROAS SMA A-1",
        "smaRoasLast2Years": "ROAS SMA A-2",
        "4xxError": "Erreur 4xx",
        "abandonedCartConversionRate": "% conversion paniers abandonnés",
        "acceptableRoas": "ROAS acceptable",
        "acceptableRoi": "ROI acceptable",
        "accessToken": "Jeton d'accès",
        "accountId": "ID compte",
        "actions": "Actions",
        "active": "Actif",
        "activeCategory": "Catégorie active",
        "activeProduct": "Produit actif",
        "activeProducts": "Produits actifs",
        "adminApiAccessToken": "Jeton d'accès API admin",
        "adCostsToTurnoverRatio": "Dépenses pub % CA",
        "addCountry": "Ajouter un pays",
        "additionalInformation": "Informations complémentaires",
        "age": "Age",
        "ages": "Ages",
        "alert": "Alerte",
        "alertAppointment": "Alerte RDV",
        "alertCategoryWithLessThanXProductsInStock": "Nombre de produits minimum en stock pour une catégorie",
        "all": "Tous",
        "allLanguages": "Toutes",
        "answer": "Réponse",
        "apikomValidationDate": "Date validation Apikom",
        "appointmentFrequency": "Récurrence RDV",
        "appointmentRequestEmail": "Mail demande RDV",
        "archived": "Archivé",
        "associatedSubAccounts": "Sous-comptes associés",
        "attachments": "Pièces jointes",
        "availableQuantity": "Qté disponible",
        "averageBasket": "Panier moyen",
        "averageCpc": "CPC moyen",
        "averageCustomerLifeTime": "Durée de vie du client",
        "averageNumberOfPurchasePerYears": "Nb moyen d'achats par an",
        "averageNumberOfPurchasesPerYears": "Nb moyen d'achats par an",
        "backlinkActiveCount": "Nombre de backlinks actifs",
        "backlinkCount": "Nombre de backlinks",
        "backlinkInactiveCount": "Nombre de backlinks inactifs",
        "backupHost": "Hôte backup",
        "backupLogin": "Nom d'utilisateur backup",
        "backupPassword": "Mot de passe backup",
        "backupStorageSpace": "Espace de stockage backup",
        "banners": "Bannières",
        "baseUrl": "URL de base",
        "billing": "Facturation",
        "bimonthly": "Bimensuel",
        "body": "Corps du message",
        "budgetNotes": "Notes budget",
        "byApikom": "By Apikom",
        "byDefault": "Par défaut",
        "cac": "CAC",
        "campaign": "Campagne",
        "cashedExcludedTaxPerMonth": "Encaissé HT/mois",
        "category": "Catégorie",
        "cartPage": "Page panier",
        "changePassword": "Changer le mot de passe",
        "checkedAt": "Vérifié le",
        "city": "Ville",
        "clicks": "Clics",
        "closed": "Fermé",
        "cloudflare": "Cloudflare",
        "cms": "CMS",
        "cmsCategoryId": "ID catégorie CMS",
        "cmsCostAttribute": "Coût attribut CMS",
        "cmsId": "ID CMS",
        "cmsProductId": "ID produit CMS",
        "cmsVersion": "V. CMS",
        "cmsVersionMaintainedUntil": "V. CMS maintenue jusqu'à",
        "codeWithValue": "Code : {value}",
        "coefficientGoogleAds": "Coef Google Ads",
        "comment": "Commentaire",
        "commitment": "Engagement",
        "comparisonActions": "Actions de comparaison",
        "comparisonClicks": "Clics de comparaison",
        "comparisonConversions": "Conversions de comparaison",
        "comparisonCosts": "Coûts de comparaison",
        "comparisonCostsToTurnoverRatio": "Coûts % CA de comparaison",
        "comparisonAdCostsToTurnoverRatio": "Dépenses pub % CA de comparaison",
        "comparisonCpa": "CPA de comparaison",
        "comparisonCpc": "CPC de comparaison",
        "comparisonCpm": "CPM de comparaison",
        "comparisonCtr": "CTR de comparaison",
        "comparisonFrequency": "Répétition de comparaison",
        "comparisonImpressions": "Impressions de comparaison",
        "comparisonReach": "Couverture de comparaison",
        "comparisonRoas": "ROAS de comparaison",
        "comparisonTotalUsers": "Nomber total d'utilisateurs de comparaison",
        "comparisonCvr": "CVR de comparaison",
        "comparisonNewUsers": "Nouveaux utilisateurs de comparaison",
        "comparisonSessions": "Sessions de comparaison",
        "comparisonSessionsPerUser": "Nombre de sessions par utilisateur de comparaison",
        "comparisonEngagementRate": "Taux d'engagement de comparaison",
        "comparisonSeaCosts": "Coûts SEA de comparaison",
        "comparisonSeaRoas": "ROAS SEA de comparaison",
        "comparisonSmaCosts": "Coûts SMA de comparaison",
        "comparisonSmaRoas": "ROAS SMA de comparaison",
        "comparisonTurnoverIncludingTax": "CA TTC de comparaison",
        "competitorsToFollow": "Concurrents à suivre",
        "connected": "Connecté",
        "contact": "Contact",
        "contactDate": "Date de contact",
        "contactEmail": "Email {index}",
        "contactName": "Nom {index}",
        "contactPhone": "Téléphone {index}",
        "content": "Contenu",
        "contents": "Contenus",
        "contentsPended": "Contenus en attente",
        "contentsProcessed": "Contenus traités",
        "contentsToProcess": "Contenus à traiter",
        "contentType": "Type de contenu",
        "conversions": "Conversions",
        "conversionsRate": "Taux de conversion",
        "conversionsValue": "Valeur conversions",
        "cost": "Coût",
        "costExcludedTax": "Coût HT",
        "costExcludedTaxPerMonth": "Coût HT/mois",
        "costs": "Coûts",
        "costsToTurnoverRatio": "Coûts % CA",
        "country": "Pays",
        "countries": "Pays",
        "cpa": "CPA",
        "cpc": "CPC",
        "cpm": "CPM",
        "ctr": "CTR",
        "createdAt": "Créé le",
        "createdBy": "Créé par",
        "createdByApikom": "Créé par Apikom",
        "createdByCustomer": "Créé par le client",
        "createdDate": "Date de création",
        "cs": "CS",
        "currentYearApikomCost": "Apikom A",
        "currentYearApikomCostToTurnoverRatio": "Apikom / CA % A",
        "currentYearSeaAndSmaCostToTurnoverRatio": "Pub / CA % A",
        "currentYearTurnoverExcludingTax": "CA HT A",
        "customer": "Client",
        "customer_tasks": "Tâches client",
        "customerFirstname": "Prénom client",
        "customerId": "ID client",
        "customerLastname": "Nom client",
        "customerName": "Nom du client",
        "customers": "Clients",
        "customerTypeCategory": "Catégorie type client",
        "customerValidationDate": "Date validation client",
        "customerWaiting": "Attente client",
        "cvr": "CVR",
        "dataType": "Type de données",
        "datakeplerModuleVersion": "Version module Datakepler",
        "date": "Date",
        "deadline": "Date limite",
        "defaultLanguage": "Langue par défaut",
        "defaultStore": "Magasin par défaut",
        "delivery": "Livraison",
        "description": "Description",
        "descriptionUpdatedAt": "Description mise à jour le",
        "desktopAverageScore": "Score moyen bureau",
        "desktopScore": "Desktop score",
        "desktopWebCoreVitals": "Desktop Web Core Vitals",
        "destinationFolder": "Dossier de destination",
        "details": "Détails",
        "dev": "DEV",
        "development": "Développement",
        "device": "Appareil",
        "devices": "Appareils",
        "devSeo": "DEV SEO",
        "discoveredAt": "Découvert le",
        "displayApikomTaskTimeFrom": "Afficher le temps des tâches Apikom depuis",
        "displayTimeOfTheCurrentMonth": "Afficher le temps du mois en cours",
        "doneAt": "Terminé le",
        "dropOutRate": "Taux d'abandon",
        "ean": "EAN",
        "ecommerce": "Ecommerce",
        "effectiveness": "Efficacité",
        "email": "Email",
        "emailing": "Emailing",
        "enabledExport": "Export activé",
        "enabledExternalServiceCount": "Nb services externes activés",
        "enabledModuleCount": "Nb modules activés",
        "enabledPdfSyncing": "Synchronisation PDF activée",
        "endDate": "Date de fin",
        "engagementRate": "% engagement",
        "estimatedCustomerLifetime": "Durée de vie estimée du client",
        "event": "Événement",
        "evolution": "Évolution",
        "exportCron": "Cron d'export",
        "exportEmails": "Emails d'export",
        "faq": "FAQ",
        "faqCount": "Nombre de FAQ",
        "fast": "Rapide",
        "file": "Fichier",
        "finalUrl": "URL finale",
        "firstname": "Prénom",
        "flowManager": "Gestionnaire de flux",
        "folderSelected": "Dossier sélectionné",
        "forceIndexation": "Forcer l'indexation",
        "formula": "Formule",
        "free": "Gratuit",
        "freeCloudflare": "Cloudflare gratuit",
        "frequency": "Fréquence",
        "from": "De",
        "fromScratch": "Depuis le début",
        "gender": "Genre",
        "genders": "Genres",
        "generalInformation": "Informations générales",
        "googleAdsRevenueContribution": "Apport CA Google Ads",
        "googleAdsSeaTracking": "Suivi SEA (Google Ads)",
        "googleWebsite": "Site Google",
        "grossLtv": "LTV brute",
        "grossMargin": "Marge brute",
        "grossMarginFormula": "Formule de la marge brute HT",
        "group": "Groupe",
        "guaranteedReviewsId": "ID Avis Garantis",
        "hasApikomContent": "A du contenu Apikom",
        "hasContentCategories": "A du contenu catégories",
        "hasContentProducts": "A du contenu produits",
        "hasCustomerAccount": "A un compte client",
        "hasEmailing": "A de l'emailing",
        "hasFacebookAdsAudience": "A des audiences Facebook Ads",
        "hasGoogleAdsAudience": "A des audiences Google Ads",
        "hasIndexation": "A de l'indexation",
        "hasInternalMesh": "A du maillage interne",
        "hasInvoicing": "A de la facturation",
        "hasMonthlyReport": "A un rapport mensuel",
        "hasNetlinking": "A du netlinking",
        "hasOpportunity": "A une opportunité",
        "hasPageSpeed": "A du temps de chargement",
        "hasPositionTracking": "A du suivi de positions",
        "hasRedirection": "A des redirections",
        "hasSms": "A du SMS",
        "hasTenantTask": "A des tâches client",
        "hasToTakeStock": "Prendre RDV",
        "hasVisitedCartPage" : "A visité la page panier",
        "hasVisitedPaymentPage" : "A visité la page paiement",
        "hasVisitedShippingPage" : "A visité la page livraison",
        "heading": "Titre {level}",
        "hideItFromTheCustomer": "Cacher au client",
        "high": "Haute",
        "hosting": "Hébergement",
        "hourly": "Horaire",
        "hoursPerMonth": "Heures/mois",
        "id": "ID",
        "identifier": "Identifiant",
        "image": "Image",
        "importantToFollow": "Important à suivre",
        "impressions": "Impressions",
        "increaseInClicks": "Estimation clics",
        "increaseInConversions": "Estimation conversions",
        "indexationStatus": "Statut d'indexation",
        "indexed": "Indexé",
        "indexedAt": "Indexé le",
        "indirect": "Indirect",
        "indirectLink": "Lien indirect",
        "interestingPackages": "Packages utiles",
        "interestingThemes": "Thèmes",
        "internalComment": "Commentaire interne",
        "internalMeshPages": "Pages maillage interne",
        "internalNetlinking": "Interne - Netlinking",
        "internalNotes": "Notes internes",
        "internalOthers": "Interne - Autres",
        "internalPositionedKeywords": "Interne - Mots-clés positionnés",
        "internalSeaComment": "Interne - Remarques SEA",
        "internalStrategyAndObjectives": "Interne - Stratégie et objectifs",
        "internalTechnicalOptimisation": "Interne - Optimisations techniques",
        "invoiced": "Facturé",
        "invoiceDate": "Date facture",
        "invoicedTime": "Temps facturé",
        "invoiceNumber": "Num facture",
        "ipBlock": "Bloc IP",
        "ipBlockCostExcludedTaxPerMonth": "Coût bloc IP HT/mois",
        "ips": "IPs",
        "isDefault": "Par défaut",
        "key": "Clé",
        "keyword": "Mot-clé",
        "language": "Langue",
        "languages": "Langues",
        "last2MonthsTurnoverExcludingTax": "CA HT M-2",
        "last2MonthsTurnoverExcludingTaxWithoutShipping": "CA HT HFP M-2",
        "lastAppointment": "Dernier RDV",
        "lastBannerDate": "Date dernière bannière",
        "lastCheckedAt": "Dernière vérification le",
        "lastCommentAt": "Dernier commentaire le",
        "lastContactAppointment": "Dernier contact",
        "lastDate": "Dernière date",
        "lastDesktopCoreWebVitalsScore": "Dernier score bureau Web Core Vitals",
        "lastDesktopScore": "Dernier score bureau",
        "lastDoneTaskAt": "Dernière tâche terminée le",
        "lastEmailDate": "Date dernier email",
        "lastEmailingDate": "Date dernier emailing",
        "lastNotInvoicedOrder": "Dernière commande non facturée",
        "lastInvoicedOrder": "Dernière commande facturée",
        "lastLoginDate": "Dernière connexion",
        "lastMobileScore": "Dernier score mobile",
        "lastMobileWebCoreVitalsScore": "Dernier score mobile Web Core Vitals",
        "lastMonthApikomCost": "Apikom M-1",
        "lastMonthApikomCostToTurnoverRatio": "Apikom / CA % M-1",
        "lastMonthCs": "CS M-1",
        "lastMonthDev": "DEV M-1",
        "lastMonthHour": "H (hors DEV) M-1",
        "lastMonthSea": "SEA M-1",
        "lastMonthSeaAndSmaCostToTurnoverRatio": "Pub / CA % M-1",
        "lastMonthSma": "SMA M-1",
        "lastMonthTurnoverExcludingTax": "CA HT M-1",
        "lastMonthTurnoverExcludingTaxWithoutShipping": "CA HT HFP M-1",
        "lastname": "Nom",
        "lastOrder": "Dernière commande",
        "lastOrderDate": "Date dernière commande",
        "lastRecurrentAppointment": "Dernier RDV récurrent",
        "lastRefundDate": "Date dernier remboursement",
        "lastReminder": "Dernière relance",
        "lastReportDate": "Dernier rapport",
        "lastReportSendDate": "Dernier envoi de rapport",
        "lastSmsDate": "Date dernier SMS",
        "lastTwoMonthTurnoverExcludingTax": "CA HT M-2",
        "lastTwoMonthTurnoverExcludingTaxWithoutShipping": "CA HT HFP M-2",
        "lastUpdatedAt": "Dernière MÀJ le",
        "lastVisitAt": "Dernière visite le",
        "lastYearApikomCost": "Apikom A-1",
        "lastYearApikomCostToTurnoverRatio": "Apikom / CA % A-1",
        "lastYearSeaAndSmaCostToTurnoverRatio": "Pub / CA % A-1",
        "lastYearTurnoverExcludingTax": "CA HT A-1",
        "latestMinimumSupportedVersion": "Dernière version minimale supportée",
        "latestVersion": "Dernière version",
        "leaveEmptyToTargetAllCountryLanguages": "Laissez vide pour cibler toutes les langues du pays",
        "leaveEmptyToUseDefault": "Laissez vide pour utiliser la valeur par défaut ( {default} )",
        "lifeTimeValue": "LTV",
        "link": "Lien",
        "linkTargetBlank": "Ouvrir le lien dans un nouvel onglet",
        "linkUrl": "Lien URL",
        "location": "Localisation",
        "locationId": "ID localisation",
        "lost": "Perdu",
        "low": "Basse",
        "magento": "Magento",
        "maintenanceCostExcludedTaxPerMonth": "Coût maintenance HT/mois",
        "marketplace": "Place de marché",
        "maxBudgetPerMonth": "Budget max/mois",
        "maxCost": "Coût max",
        "maxDate": "Date max",
        "maxDateCompleted": "Date max terminée",
        "maxDateCurrent": "Date max en cours",
        "maxProcessedDate": "Date max traitée",
        "maxSentAt": "Date max envoyée",
        "meansOfCommunication": "Moyen de communication",
        "medium": "Moyen",
        "meeting": "RDV",
        "meetingAtTheCustomer": "RDV chez le client",
        "message": "Message",
        "metaAdsSmaTracking": "Suivi SMA (Meta Ads)",
        "metaDescription": "Méta-description",
        "metaTitle": "Méta-titre",
        "minCost": "Coût min",
        "minimalGrossRoas": "ROAS brut",
        "minimalNetRoas": "ROAS net",
        "minimalRecommendedRoas": "ROAS min recommandée",
        "minimalRoas": "ROAS min",
        "minimalTargetRoas": "ROAS cible min",
        "mobileAverageScore": "Score moyen mobile",
        "mobileScore": "Score mobile",
        "mobileWebCoreVitals": "Mobile Web Core Vitals",
        "module": "Module",
        "moduleNames": "Noms modules",
        "moduleVersions": "Versions modules",
        "monthly": "Mensuel",
        "n": "N",
        "name": "Nom",
        "netlinking": "Netlinking",
        "netlinkingBudgetPerMonth": "Budget Netlinking/mois",
        "netLtv": "LTV nette",
        "netMarginFormula": "Formule de la marge nette HT",
        "new": "Nouveau",
        "newUsers": "Nouveaux utilisateurs",
        "newSalePrice": "PV Neuf",
        "nextAppointment": "Prochain RDV",
        "nLanguages": "0 langue | 1 langue | {count} langues",
        "no": "Non",
        "noFolderSelected": "Aucun dossier sélectionné",
        "noFollow": "No follow",
        "noOneResponsible": "Aucun responsable",
        "noPrincipalTaskManagers": "Responsables tâches (autres)",
        "notConnected": "Non connecté",
        "notIndexed": "Désindexé",
        "notIndexedAt": "Désindexé le",
        "notes": "Notes",
        "nTargets": "0 cible | 1 cible | {count} cibles",
        "numberOfBannersPerMonth": "Nb de bannières/mois",
        "numberOfCustomersSynchronised": "Nombre de clients synchronisés",
        "numberOfEmailingPerMonth": "Nb d'emailing/mois",
        "numberOfInternalMeshPagesPerMonth": "Nb de pages maillage interne/mois",
        "numberOfNetlinkingLinksPerMonth": "Nb de liens netlinking/mois",
        "numberOfPremiumContentsPerMonth": "Nb de contenus premium/mois",
        "numberOfProducts": "Nb produits",
        "numberOfStandardContentsPerMonth": "Nb de contenus standard/mois",
        "numberOfUserTestsPerQuarter": "Nb de tests utilisateurs/trimestre",
        "oldNotDoneTaskCreatedAt": "Data tâche à traiter",
        "ongoing": "En cours",
        "onHold": "En attente",
        "onlyMarketplace": "Seulement la place de marché",
        "onlyPointOfSales": "Seulement le point de vente",
        "onlyStore": "Seulement le magasin",
        "open": "Ouvert",
        "opinions": "Avis",
        "orderAt": "Commandé le",
        "orderDate": "Date commande",
        "orderNumber": "Num commande",
        "orderReference": "Référence commande",
        "orders": "Commandes",
        "other": "Autre",
        "others": "Autres",
        "otherServers": "Autres serveurs",
        "outsourcing": "Infogérance",
        "package": "Forfait",
        "page_speed": "Page Speed",
        "pageId": "ID page",
        "pageTitle": "Titre page",
        "paid": "Payé",
        "paragraph": "Paragraphe",
        "partiallyInvoiced": "Partiellement facturé",
        "partner": "Partenaire",
        "password": "Mot de passe",
        "passwordConfirmation": "Confirmation du mot de passe",
        "payment": "Paiement",
        "paymentMethods": "Moyens de paiement",
        "paymentModules": "Modules de paiement",
        "paymentPage": "Page de paiement",
        "pended": "En attente",
        "pendedAt": "En attente le",
        "pendedTotal": "Total en attente",
        "pending": "En attente",
        "percentageOfAcceptableCosts": "% dépenses acceptable",
        "percentageOfAcceptableRoas": "% ROAS acceptable",
        "performancePercentage": "%/perf",
        "performanceStage": "Palier/perf",
        "period": "Période",
        "permanentRedirect": "Redirection permanente",
        "phone": "Téléphone",
        "photo": "Photo",
        "phpVersion": "V. PHP",
        "phpVersionMaintainedUntil": "V. PHP maintenue jusqu'à",
        "phpVersions": "Versions PHP",
        "position": "Position",
        "positionedKeywords": "Mots-clés positionnés",
        "postcode": "Code postal",
        "potentialTurnover": "CA potentiel",
        "premium": "Premium",
        "premiumContents": "Contenus premium",
        "prestashop": "PrestaShop",
        "preview": "Preview",
        "price": "Prix",
        "principalTaskManagers": "Responsables tâches (principaux)",
        "priority": "Priorité",
        "processed": "Traitée",
        "processedAt": "Traitée le",
        "processedTotal": "Total traité",
        "proCloudflare": "Cloudflare pro",
        "product": "Produit",
        "productAttributes": "Attributs produit",
        "productsCostExcludedTax": "Coût produits HT",
        "productFeatures": "Caractéristiques produit",
        "productsMarginExcludedTax": "Marge produits HT",
        "productTurnoverWebsite": "CA produit site",
        "productVariation": "Variation de produit",
        "profitability": "Rentabilité",
        "project": "Projet",
        "publicKey": "Clé publique",
        "publishedAt": "Publié le",
        "qty": "Qté",
        "qtyOrdered": "Qté achétée",
        "qtyRefunded": "Qté remboursée",
        "quantity": "Qté",
        "quantityAvailable": "Qté disponible",
        "quantitySold": "Qté vendue",
        "quarterly": "Trimestriel",
        "question": "Question",
        "quotationLink": "Lien devis",
        "rateOfBasketSales": "Taux de réalisation du CA panier",
        "rating": "Note",
        "reach": "Couverture",
        "realTime": "Temps",
        "recurrent": "Récurrent",
        "reference": "Référence",
        "referenceType": "Type de référence",
        "refundDate": "Date remboursement",
        "refundNumber": "Num remboursement",
        "refunds": "Remboursements",
        "refundTurnover": "CA remboursé",
        "reply": "Réponse",
        "replyAt": "Répondu le",
        "requirements": "Besoins",
        "responsible": "Responsable",
        "returnOnAdSpend": "ROAS",
        "review": "Avis",
        "roas": "ROAS",
        "roles": "Rôles",
        "scheduledAt": "Planifié le",
        "sea": "SEA",
        "seaCosts": "Coûts SEA",
        "seaRoas": "ROAS SEA",
        "search": "Recherche",
        "security": "Sécurité",
        "seeDocument": "Voir le document",
        "sem": "SEM",
        "semiannual": "Semestriel",
        "sentAt": "Envoyé le",
        "seo": "SEO",
        "seoTracking": "Suivi SEO",
        "serialNumber": "Numéro de série",
        "serverCostExcludedTaxPerMonth": "Coût serveur HT/mois",
        "serverName": "Nom du serveur",
        "serviceStartDate": "Début prestation",
        "severity": "Gravité",
        "sessions": "Sessions",
        "sessionsPerUser": "Nb sessions/utilisateur",
        "shipmentDate": "Date expédition",
        "shipmentNumber": "Num expédition",
        "shipping": "Livraison",
        "shippingCountry": "Pays livraison",
        "shippingPaid": "Livraison payée",
        "shippingPage": "Page livraison",
        "shippingPostcode": "CP livraison",
        "shopify": "Shopify",
        "shoppingfeed": "Shoppingfeed",
        "shortDescription": "Description courte",
        "shortName": "Nom court",
        "signedQuotationLink": "Lien devis signé",
        "sitemap": "Sitemap",
        "sitemapName": "Nom du sitemap",
        "siteUrl": "URL du site",
        "sku": "SKU",
        "slow": "Lent",
        "sma": "SMA",
        "smaCosts": "Coûts SMA",
        "smaRoas": "ROAS SMA",
        "smo": "SMO",
        "sms": "SMS",
        "sourceAnchor": "Ancre source",
        "sourceUrl": "URL source",
        "sourceUrls": "URLs source",
        "special": "Spécial",
        "standard": "Standard",
        "standardContents": "Contenus standard",
        "startDate": "Date de début",
        "state": "État",
        "status": "Statut",
        "statusCode": "Code statut",
        "storeName": "Nom du magasin",
        "store": "Magasin",
        "stores": "Magasins",
        "strategy": "Stratégie",
        "strategyAndObjectives": "Stratégie et objectifs",
        "subject": "Sujet",
        "submittedAndIndexedTotal": "Total soumis/indexés",
        "suggestedGooglePrice": "Prix suggéré Google",
        "synchronizedAt": "Synchronisé le",
        "syncingFromDate": "Synchronisation depuis le",
        "t": "T",
        "targets": "Cibles",
        "targetUrl": "URL cible",
        "taskManager": "Responsable tâche",
        "taskReminderEmailSentAt": "Email de rappel envoyé le",
        "taskToProcessCount": "NB tâches à traiter",
        "tel": "Tél",
        "telephone": "Téléphone",
        "text": "Texte",
        "theme": "Thème",
        "time": "Temps",
        "title": "Titre",
        "to": "À",
        "toCall": "À relancer",
        "toInvoice": "À facturer",
        "toProcess": "À traiter",
        "toProcessTotal": "Total à traiter",
        "total": "Total",
        "total301": "Total 301",
        "total410": "Total 410",
        "totalCloudflareCostExcludedTaxPerMonth": "Coût Cloudflare HT/mois",
        "totalCost": "Coût total",
        "totalCostExcludedTaxPerMonth": "Coût total HT/mois",
        "totalExcludingTax": "Total HT",
        "totalIncludingTax": "Total TTC",
        "totalProductsExcludingTax": "Total produits HT",
        "totalProductsIncludingTax": "Total produits TTC",
        "totalProductsTax": "Total TVA produits",
        "totalQtyRefunded": "Qté totale remboursée",
        "totalShippingExcludingTax": "Total livraison HT",
        "totalShippingIncludingTax": "Total livraison TTC",
        "totalShippingTax": "Total TVA livraison",
        "totalTax": "Total TVA",
        "totalUsers": "Nb total utilisateurs",
        "transactionIds": "IDs transaction",
        "turnover": "CA",
        "turnoverIncludingTax": "CA TTC",
        "turnoverIncludingTaxAbandonedCarts": "CA TTC paniers abandonnées",
        "turnoverIncludingTaxCarts": "CA TTC paniers",
        "turnoverIncludingTaxSales": "CA TTC ventes",
        "turnoverOrdered": "CA achété",
        "turnoverRatio": "% CA",
        "turnoverRefunded": "CA remboursé",
        "turnoverToTotalQuantityRatio": "CA/Qté",
        "twiceYearly": "Semestriel",
        "twoFactorAuthenticationEnabled": "2FA Admin activé",
        "cspEnabled": "CSP activés",
        "type": "Type",
        "unitCost": "Coût unitaire",
        "unitPriceIncludingTax": "Prix unitaire TTC",
        "updatedAt": "Mis à jour le",
        "url": "URL",
        "urlCount": "NB URLs",
        "urls": "URLs",
        "urlSource": "URL source",
        "urlTarget": "URL cible",
        "useDefaultValue": "Utiliser la valeur par défaut",
        "usedSalePrice": "PV Occasion",
        "userCount": "NB utilisateurs",
        "users": "Utilisateurs",
        "userTests": "Tests utilisateurs",
        "verifiedReviewsId": "ID Avis Vérifiés",
        "version": "Version",
        "videoconference": "Visioconférence",
        "visibleProduct": "Produit visible",
        "website": "Site",
        "websiteId": "ID site",
        "websiteVariant": "Site",
        "weekly": "Hebdomadaire",
        "withoutDescription": "Sans description",
        "withoutMetaDescription": "Sans méta-description",
        "withoutMetaTitle": "Sans méta-titre",
        "withoutShortDescription": "Sans description courte",
        "won": "Gagné",
        "yearly": "Annuel",
        "yes": "Oui"
    },
    "permission": {
        "manage_external_services": "Gérer les services externes",
        "manage_modules": "Gérer les modules",
        "manage_roles": "Gérer les rôles",
        "manage_users": "Gérer les utilisateurs",
        "manage_website_variants": "Gérer les sites",
        "view_accounting": "Voir la comptabilité",
        "view_apikom": "Voir les informations d'Apikom",
        "view_apikom_customer_tasks": "Voir les tâches client d'Apikom",
        "view_apikom_seo": "Voir le SEO d'Apikom",
        "view_apikom_service": "Voir le service d'Apikom",
        "view_apikom_strategy_and_objectives": "Voir le rapport d'Apikom",
        "view_apikom_tasks": "Voir les tâches d'Apikom",
        "view_customers": "Voir les clients",
        "view_customers_segmentation": "Voir la segmentation des clients",
        "view_dashboard": "Voir le tableau de bord",
        "view_dashboard_projection": "Voir la projection du tableau de bord",
        "view_dev": "Voir les informations de développement",
        "view_dev_performance": "Voir les informations de performance",
        "view_dev_server_info": "Voir les informations du serveur",
        "view_dev_uptime_monitor": "Voir le moniteur de temps de fonctionnement",
        "view_dev_website_info": "Voir les informations du site Web",
        "view_e-reputation": "Voir l'e-réputation",
        "view_e-reputation_customers_reviews": "Voir les avis clients de l'e-réputation",
        "view_e-reputation_requests_reviews": "Voir les demandes d'avis de l'e-réputation",
        "view_erp": "Voir les informations de l'ERP",
        "view_erp_inventory": "Voir l'inventaire de l'ERP",
        "view_erp_inventory_supply": "Voir l'approvisionnement de l'inventaire de l'ERP",
        "view_erp_inventory_supply_movements": "Voir les mouvements d'approvisionnement de l'inventaire de l'ERP",
        "view_erp_product_data": "Voir les données de produit de l'ERP",
        "view_google_analytics": "Voir Google Analytics",
        "view_google_search_console": "Voir la console de recherche Google",
        "view_inventory": "Voir l'inventaire",
        "view_invoices": "Voir les factures",
        "view_marketing_automation": "Voir l'automatisation du marketing",
        "view_products": "Voir les produits",
        "view_refunds": "Voir les remboursements",
        "view_sales": "Voir les informations de vente",
        "view_sales_shipment_tracking": "Voir le suivi des expéditions de vente",
        "view_sea": "Voir les informations de SEA",
        "view_sea_google_ads": "Voir les annonces Google de SEA",
        "view_sea_google_ads_search": "Voir les annonces de recherche Google de SEA",
        "view_sea_google_ads_shopping": "Voir les annonces Google Shopping de SEA",
        "view_sem": "Voir le SEM",
        "view_seo": "Voir les informations de SEO",
        "view_seo_content": "Voir le contenu de SEO",
        "view_seo_indexation": "Voir l'indexation de SEO",
        "view_seo_netlinking": "Voir le netlinking de SEO",
        "view_seo_tracking_position": "Voir le suivi de positions de SEO",
        "view_shipments": "Voir les expéditions",
        "view_sma": "Voir les informations de SMA",
        "view_sma_facebook": "Voir les informations de Facebook de SMA",
        "view_sma_facebook_lead_ads": "Voir les annonces de leads Facebook de SMA",
        "view_smo": "Voir les informations de SMO",
        "view_smo_editorial": "Voir l'éditorial de SMO",
        "view_smo_facebook": "Voir Facebook de SMO",
        "view_smo_google_my_business": "Voir Google My Business de SMO",
        "view_smo_instagram": "Voir Instagram de SMO",
        "view_smo_reputation": "Voir la réputation de SMO",
        "view_statistics": "Voir les statistiques",
        "view_top_categories": "Voir les catégories les plus consultées",
        "view_top_products": "Voir les produits les plus consultés"
    },
    "placeholder": {
        "selectCustomer": "Sélectionner un client"
    },
    "role": {
        "admin": "Admin",
        "dashboard_viewer": "Multicompte",
        "super_admin": "Super Admin",
        "super-admin": "Super Admin",
        "super-admin-datakepler": "Super Admin Datakepler"
    },
    "suffix": {
        "years": "an(s)",
        "days": "jour(s)"
    },
    "text": {
        "oneKeywordPerLine": "Un mot-clé par ligne",
        "actions": "Nombre d'actions",
        "actionsThisMonthAndYear": "Nombre d'actions en {month} {year}",
        "actionsNotCurrentlyAvailable": "Ces actions ne sont pas actuellement disponibles.",
        "adCostsToTurnoverRatio": "Ratio investissement publicitaire sur Chiffre d'Affaires TTC",
        "adCostsToTurnoverRatioThisMonthAndYear": "Ratio investissement publicitaire sur Chiffre d'Affaires TTC en {month} {year}",
        "adCostsToTurnoverRatioLast30DaysCompareLastYear": "Ratio investissement publicitaire sur Chiffre d'Affaires TTC sur les 30 derniers jours comparé à l'année dernière",
        "adCostsThisMonthAndYear": "Investissement publicitaire en {month} {year}",
        "anyCustomerSelected": "Aucun client sélectionné.",
        "apikomContentCountThisMonthAndYear": "Nombre de contenus Apikom en {month} {year}",
        "apikomContentCountThisYear": "Nombre de contenus Apikom en {year}",
        "areYouSureToDeleteAffiliation": "Êtes-vous sûr de vouloir supprimer l'affiliation #{id} ?",
        "areYouSureToDeleteApikomContent": "Êtes-vous sûr de vouloir supprimer le contenu Apikom #{id} ?",
        "areYouSureToDeleteAppointment": "Êtes-vous sûr de vouloir supprimer le rendez-vous #{id} ?",
        "areYouSureToDeleteAudience": "Êtes-vous sûr de vouloir supprimer l'audience #{id} ?",
        "areYouSureToDeleteBacklink": "Êtes-vous sûr de vouloir supprimer le backlink #{id} ?",
        "areYouSureToDeleteBanner": "Êtes-vous sûr de vouloir supprimer la bannière #{id} ?",
        "areYouSureToDeleteCallbackRequest": "Êtes-vous sûr de vouloir supprimer la demande de rappel #{id} ?",
        "areYouSureToDeleteCustomerUser": "Êtes-vous sûr de vouloir supprimer l'utilisateur #{tenantUserId} du client {tenantName} ?",
        "areYouSureToDeleteEmailing": "Êtes-vous sûr de vouloir supprimer l'emailing #{id} ?",
        "areYouSureToDeleteEvent": "Êtes-vous sûr de vouloir supprimer l'événement #{id} ?",
        "areYouSureToDeleteFaq": "Êtes-vous sûr de vouloir supprimer la FAQ #{id} ?",
        "areYouSureToDeleteIndexationSitemap": "Êtes-vous sûr de vouloir supprimer le sitemap d'indexation #{id} ?",
        "areYouSureToDeleteInternalMeshLink": "Êtes-vous sûr de vouloir supprimer le lien du maillage interne #{id} ?",
        "areYouSureToDeletePageSpeedUrl": "Êtes-vous sûr de vouloir supprimer l'URL de temps de chargement #{id} ?",
        "areYouSureToDeletePartner": "Êtes-vous sûr de vouloir supprimer le partenaire #{id} ?",
        "areYouSureToDeleteProspect": "Êtes-vous sûr de vouloir supprimer le prospect #{id} ?",
        "areYouSureToDeleteQuotation": "Êtes-vous sûr de vouloir supprimer le devis #{id} ?",
        "areYouSureToDeleteRedirection": "Êtes-vous sûr de vouloir supprimer la redirection #{id} ?",
        "areYouSureToDeleteSegmentation": "Êtes-vous sûr de vouloir supprimer la segmentation #{id} ?",
        "areYouSureToDeleteSms": "Êtes-vous sûr de vouloir supprimer le SMS #{id} ?",
        "areYouSureToDeleteTest": "Êtes-vous sûr de vouloir supprimer le test #{id} ?",
        "areYouSureToDeleteTrackingKeyword": "Êtes-vous sûr de vouloir supprimer le mot-clé de suivi #{id} ?",
        "areYouSureToDeleteUser": "Êtes-vous sûr de vouloir supprimer l'utilisateur #{userId} ?",
        "areYouSureToDeleteUserTest": "Êtes-vous sûr de vouloir supprimer le test utilisateur #{id} ?",
        "areYouSureToDeleteWebsiteVariant": "Êtes-vous sûr de vouloir supprimer le site #{variantId} ?",
        "averageBasket": "Ratio nombre de commandes sur Chiffre d'Affaires",
        "averageBasketThisMonthAndYear": "Ratio nombre de commandes sur Chiffre d'Affaires en {month} {year}",
        "averageBasketWithDays": "Ratio nombre de commandes sur Chiffre d'Affaires sur les {days} derniers jours",
        "averageCustomerLifeTime": "Durée de vie moyenne du client",
        "averageDelayBetweenPurchases": "Délai moyen entre 2 commandes",
        "averageDevPageSpeed": "Temps de chargement moyen ({type}) : {score}",
        "averageNumberOfPurchasePerYears": "Nombre moyen d'achats par an",
        "averagePageSpeedScoreDesktop": "Score moyen de temps du chargement desktop (dernier passage le {date})",
        "averagePageSpeedScoreMobile": "Score moyen de temps du chargement mobile (dernier passage le {date})",
        "averageRefundRate": "{percent}% des commandes sont remboursées",
        "averageWebsiteRating": "Note moyenne du site",
        "averageWebsiteRatingThisMonthAndYear": "Note moyenne du site en {month} {year}",
        "backlinkCountThisMonthAndYear": "Nombre de liens achetés en {month} {year}",
        "backlinkCountThisYear": "Nombre de liens achetés en {year}",
        "baseCost": "Coût de base : {cost}",
        "cac": "Montant moyen investi en publicité pour obtenir la première commande d'un nouveau client",
        "cartConversionRate": "Ratio nombre de commandes sur nombre de paniers",
        "cartCount": "Nombre de paniers",
        "clicks": "Nombre de clics",
        "clicksThisMonthAndYear": "Nombre de clics en {month} {year}",
        "complexSupplyCreate": "Ce mode de création avancé génère des fichiers CSV à importer dans l'ERP. Aucun stock / approvisionnement n'est créé dans l'ERP à partir de cette interface.",
        "contentTypeAreNotTheSame": "Les types de contenu ne sont pas les mêmes.",
        "conversions": "Nombre de conversions",
        "conversionsThisMonthAndYear": "Nombre de conversions en {month} {year}",
        "conversionRateAfterFirstPurchase": "{percent}% des clients ayant commandé une fois passent une 2eme commande",
        "cost": "Investissement",
        "costs": "Investissements",
        "costsThisMonthAndYear": "Investissement en {month} {year}",
        "costsToOrderTurnoverRatio": "Ratio investissement sur Chiffre d'Affaires TTC",
        "costsToOrderTurnoverRatioThisMonthAndYear": "Ratio investissement sur Chiffre d'Affaires TTC en {month} {year}",
        "costToClicksRatio": "Ratio investissement sur nombre de clics",
        "costToTurnoverRatio": "Ratio investissement sur Chiffre d'Affaires",
        "cpa": "Ratio investissement sur nombre d'actions",
        "cpc": "Ratio investissement sur nombre de clics",
        "cpm": "Ratio investissement sur nombre d'impressions",
        "ctr": "Ratio nombre de clics sur nombre d'impressions",
        "cvr": "Ratio actions sur nombre de clics",
        "error": "Une erreur est survenue.",
        "error403": "Vous n'avez pas les droits pour accéder à cette page.",
        "error404": "La page que vous cherchez n'existe pas.",
        "error500": "Une erreur serveur est survenue.",
        "error503": "Le serveur est indisponible pour cause de maintenance.",
        "engagementRate": "Taux d'engagement",
        "engagementRateThisMonthAndYear": "Taux d'engagement en {month} {year}",
        "frequency": "Ratio nombre d'impressions sur couverture",
        "fromTo": "Du {from} au {to}",
        "fromToDate": "Du {fromDate} au {toDate}",
        "googleMyBusinessAverageRating": "Note moyenne du site sur Google My Business",
        "googleMyBusinessTotalRating": "Total des notes du site sur Google My Business",
        "googleMyBusinessTotalRatingLast30Days": "Total des notes du site sur Google My Business sur les 30 derniers jours",
        "grossLtv": "CA total moyen qu'un client génère sur toute sa durée de vie",
        "grossMargin": "CA HT - Coût produits HT - Frais de ports - Remboursements",
        "grossMarginExclTax": "Estimation marge brute HT configurable",
        "grossMarginExcludingTax": "Estimation marge brute HT configurable",
        "grossMarginExcludingTaxToTurnoverRatio": "Estimation du ratio marge brute HT sur Chiffre d'Affaires",
        "grossMarginToTurnoverRatio": "Estimation du ratio marge brute sur Chiffre d'Affaires",
        "grossRoas": "Le CA réel généré pour chaque euro investi en publicité",
        "guaranteedReviewsWebsiteAverageRating": "Note moyenne du site sur Avis Garantis",
        "guaranteedReviewsWebsiteTotalRating": "Total des notes du site sur Avis Garantis",
        "guaranteedReviewsWebsiteTotalRatingLast30Days": "Total des notes du site sur Avis Garantis sur les 30 derniers jours",
        "impressions": "Nombre d'impressions",
        "indexedPageCount": "Nombre de pages indexées (dernière mise à jour le {date})",
        "internalMeshLinkCountThisMonthAndYear": "Nombre de pages en maillage interne en {month} {year}",
        "internalMeshLinkCountThisYear": "Nombre de pages en maillage interne en {year}",
        "lastCurrentCmsVersion": "Dernière version du CMS courant disponible : <b>{version}</b>",
        "lastUpdateAt": "Dernière mise à jour le {date}",
        "loading": "Chargement en cours...",
        "minimalTargetRoas": "Le seuil de rentabilité réel : c'est le CA minimum qu'il faut obligatoirement atteindre par euro dépensé en publicité pour être vraiment rentable",
        "netLtv": "Bénéfice total moyen qu'un client génère sur toute sa durée de vie",
        "netMarginExclTax": "Estimation marge nette HT configurable",
        "netMarginExcludingTax": "Estimation marge nette HT configurable",
        "netMarginExcludingTaxToTurnoverRatio": "Estimation du ratio marge nette HT sur Chiffre d'Affaires",
        "netMarginToTurnoverRatio": "Estimation du ratio marge nette sur Chiffre d'Affaires",
        "netRoas": "Le bénéfice réel (en tenant compte de la marge brute) généré pour chaque euro investi en publicité",
        "newUsers": "Nombre de nouveaux utilisateurs",
        "newUsersThisMonthAndYear": "Nombre de nouveaux utilisateurs en {month} {year}",
        "noAppointments": "Aucun",
        "noNotesAvailable": "Aucune note disponible.",
        "noReportAvailable": "Aucun rapport disponible.",
        "numberOfFacebookFollowers": "Nombre de followers Facebook",
        "numberOfFacebookFollowersThisMonthAndYear": "Nombre de followers Facebook en {month} {year}",
        "numberOfFollowers": "Nombre de followers",
        "numberOfInstagramFollowers": "Nombre de followers Instagram",
        "numberOfNewFacebookFollowers": "Nombre de nouveaux followers Facebook",
        "numberOfNewFacebookFollowersThisMonthAndYear": "Nombre de nouveaux followers Facebook en {month} {year}",
        "numberOfNewFacebookFollowersLast30Days": "Nombre de nouveaux followers Facebook sur les 30 derniers jours",
        "numberOfNewFollowers": "Nombre de nouveaux followers",
        "numberOfNewFollowersThisMonthAndYear": "Nombre de nouveaux followers en {month} {year}",
        "numberOfNewInstagramFollowers": "Nombre de nouveaux followers Instagram",
        "numberOfNewInstagramFollowersThisMonthAndYear": "Nombre de nouveaux followers Instagram en {month} {year}",
        "numberOfNewInstagramFollowersLast30Days": "Nombre de nouveaux followers Instagram sur les 30 derniers jours",
        "numberOfOrders": "Nombre de commandes",
        "numberOfOrdersLast30DaysCompareLastYear": "Nombre de commandes sur les 30 derniers jours comparé à l'année dernière",
        "orderCount": "Nombre de commandes",
        "orderCountThisMonthAndYear": "Nombre de commandes en {month} {year}",
        "pageCount": "Nombre de pages (dernière mise à jour le {date})",
        "pendingInternalMeshLinkCount": "Nombre de pages en attente de validation",
        "phpVersionNotMaintained": "La version PHP <b>{version}</b> n'est plus maintenue.",
        "premiumContentCountThisMonthAndYear": "Nombre de contenus premium en {month} {year}",
        "premiumContentCountThisYear": "Nombre de contenus premium en {year}",
        "priceInDate": "{price} en {date}",
        "productsTurnoverExcludingTax": "Chiffre d'Affaires HT des produits",
        "productsTurnoverIncludingTax": "Chiffre d'Affaires TTC des produits",
        "reach": "Nombre de personne ayant vu au moins une fois une publicité",
        "refundCount": "Nombre de remboursements",
        "refundCountThisMonthAndYear": "Nombre de remboursements en {month} {year}",
        "refunds": "Remboursements",
        "refundsThisMonthAndYear": "Remboursements en {month} {year}",
        "refundsToTurnoverRatio": "Ratio remboursements sur Chiffre d'Affaires",
        "refundsToTurnoverRatioThisMonthAndYear": "Ratio remboursements sur Chiffre d'Affaires en {month} {year}",
        "refundSum": "Montant total des remboursements",
        "returnOnAdSpend": "Retour sur investissement pour 1€ dépensé",
        "roas": "Retour sur investissement pour 1€ dépensé",
        "roasThisMonthAndYear": "Retour sur investissement pour 1€ dépensé en {month} {year}",
        "seaAndSmaCost": "Coût pub",
        "seaAndSmaCostToTurnoverRatio": "Ratio investissement publicitaire sur Chiffre d'Affaires TTC",
        "seaCost": "Investissement Google Ads",
        "seaCostsToTurnoverRatio": "Ratio investissement Google Ads sur Chiffre d'Affaires TTC",
        "seaCostsToTurnoverRatioLast30DaysCompareLastYear": "Ratio investissement Google Ads sur Chiffre d'Affaires TTC sur les 30 derniers jours comparé à l'année dernière",
        "seaCostToTurnoverRatio": "Ratio investissement Google Ads sur Chiffre d'Affaires TTC",
        "seaReturnOnAdSpend": "Retour sur investissement Google Ads pour 1€ dépensé",
        "seaRoas": "Retour sur investissement Google Ads pour 1€ dépensé",
        "seaRoasLast30DaysCompareLastYear": "Retour sur investissement Google Ads pour 1€ dépensé sur les 30 derniers jours comparé à l'année dernière",
        "seaTopClickKeyword": "{keyword} a été cliqué {clicks} fois",
        "seaTopClickKeywords": "Les mots clés les plus cliqués sont :",
        "seaTopImpressionKeyword": "{keyword} a été vu {impressions} fois",
        "seaTopImpressionKeywords": "Les mots clés avec le plus d’impression sont :",
        "seaTotalClicks": "{clicks} clics en {date}",
        "seaTotalConversions": "{conversions} conversions en {date}",
        "seaTotalCost": "{cost} ont été dépensés en {date}",
        "seoApikomContentCountByDate": "1 contenu a été optimisé en {date} | {count} contenus ont été optimisés en {date}",
        "seoBacklinkCountByDate": "1 lien a été acheté en {date} | {count} liens ont été achetés en {date}",
        "seoIndexedPageCount": "1 page indexée sur {totalPageCount} page(s) le {maxDate} | {indexedPageCount} pages indexées sur {totalPageCount} page(s) le {maxDate}",
        "seoInternalMeshLinkCountByDate": "1 page a été optimisée en maillage interne en {date} | {count} pages ont été optimisées en maillage interne en {date}",
        "seoPendingApikomContentCountByDate": "1 contenu est en attente de validation en {date} | {count} contenus sont en attente de validation en {date}",
        "seoPendingInternalMeshLinkCountByDate": "1 page est en attente de validation en {date} | {count} pages sont en attente de validation en {date}",
        "seoTopTrackedKeywordCount": "{topTrackedKeywordCount} mots clés sur {totalTrackedKeywordCount} sont en TOP {topNumber}",
        "seoTotalTrackedKeywordCount": "1 mot clé est suivi le { maxDate } | {count} mots clés sont suivis (dernière mise à jour le { maxDate })",
        "separateEmailsByComma": "Séparez les emails par une virgule",
        "sessionsPerUser": "Nombre de sessions par utilisateur",
        "sessionsPerUserThisMonthAndYear": "Nombre de sessions par utilisateur en {month} {year}",
        "sessions": "Nombre de sessions",
        "sessionsThisMonthAndYear": "Nombre de sessions en {month} {year}",
        "shippingTurnoverExcludingTax": "Chiffre d'Affaires HT des frais de port",
        "shippingTurnoverIncludingTax": "Chiffre d'Affaires TTC des frais de port",
        "singleSeoTopTrackedKeywordCount": "{topTrackedKeywordCount} mot clé sur {totalTrackedKeywordCount} est en TOP {topNumber}",
        "smaCost": "Investissement Médias Sociaux",
        "smaCostsToTurnoverRatio": "Ratio investissement Médias Sociaux sur Chiffre d'Affaires TTC",
        "smaCostsToTurnoverRatioLast30DaysCompareLastYear": "Ratio investissement Médias Sociaux sur Chiffre d'Affaires TTC sur les 30 derniers jours comparé à l'année dernière",
        "smaCostToTurnoverRatio": "Ratio investissement Médias Sociaux sur Chiffre d'Affaires TTC",
        "smaReturnOnAdSpend": "Retour sur investissement Médias Sociaux pour 1€ dépensé",
        "smaRoas": "Retour sur investissement Médias Sociaux pour 1€ dépensé",
        "smaRoasLast30DaysCompareLastYear": "Retour sur investissement Médias Sociaux pour 1€ dépensé sur les 30 derniers jours comparé à l'année dernière",
        "sourceUrlsLegend": "Une URL source par ligne",
        "standardContentCountThisMonthAndYear": "Nombre de contenus standard en {month} {year}",
        "standardContentCountThisYear": "Nombre de contenus standard en {year}",
        "technicalSeoOptimization": "Optimisations techniques SEO",
        "the": "Le {date}",
        "theDate": "Le {date}",
        "thinkToUpdateDescriptionUpdatedAt": "Pensez à mettre à jour le champ 'Description mis à jour le' si vous avez modifié la description.",
        "topTrackedKeywordCount": "Nombre de mots clés en top {top} (dernière mise à jour le {date})",
        "topTrackedKeywordCountLast30Days": "Nombre de mots clés en top {top} suivis sur les 30 derniers jours (dernière mise à jour le {date})",
        "totalRefundsIncludingTax": "Total des remboursements net",
        "totalUsers": "Nombre total des utilisateurs",
        "totalUsersThisMonthAndYear": "Nombre total des utilisateurs en {month} {year}",
        "totalWebsiteRating": "Total des notes du site",
        "totalWebsiteRatingThisMonthAndYear": "Total des notes du site en {month} {year}",
        "trackedKeywordCount": "Nombre de mots clés suivis (dernière mise à jour le {date})",
        "trackedKeywordCountLast30Days": "Nombre de mots clés suivis sur les 30 derniers jours (dernière mise à jour le {date})",
        "turnover": "Chiffre d'Affaires TTC",
        "turnoverExclTax": "Chiffre d'Affaires HT",
        "turnoverExclTaxWithoutShipping": "Chiffre d'Affaires HT hors frais de port",
        "turnoverExcludingTax": "Chiffre d'Affaires HT",
        "turnoverExcludingTaxAndExcludingShippingCosts": "Chiffre d'Affaires HT hors frais de port",
        "turnoverExcludingTaxAndExcludingShippingCostsThisMonthAndYear": "Chiffre d'Affaires HT hors frais de port en {month} {year}",
        "turnoverExcludingTaxThisMonthAndYear": "Chiffre d'Affaires HT en {month} {year}",
        "turnoverIncludingTax": "Chiffre d'Affaires TTC",
        "turnoverIncludingTaxAndExcludingShippingCosts": "Chiffre d'Affaires TTC hors frais de port",
        "turnoverIncludingTaxAndExcludingShippingCostsThisMonthAndYear": "Chiffre d'Affaires TTC hors frais de port en {month} {year}",
        "turnoverIncludingTaxLast30DaysCompareLastYear": "Chiffre d'Affaires TTC sur les 30 derniers jours comparé à l'année dernière",
        "turnoverIncludingTaxThisMonthAndYear": "Chiffre d'Affaires TTC en {month} {year}",
        "turnoverWithoutShipping": "Chiffre d'Affaires TTC hors frais de port",
        "untrackedTasks": "Nombre de tâches non traitées",
        "unknownVersion": "Version inconnue",
        "urlsLegend": "Une URL par ligne",
        "verifiedReviewsWebsiteAverageRating": "Note moyenne du site sur Avis Vérifiés sur les 12 derniers mois",
        "verifiedReviewsWebsiteTotalRating": "Total des notes du site sur Avis Vérifiés sur les 12 derniers mois",
        "verifiedReviewsWebsiteTotalRatingLast30Days": "Total des notes du site sur Avis Vérifiés sur les 30 derniers jours",
        "youHaveXTasks": "Vous avez 1 tâche en attente | Vous avez {count} tâches en attente"
    },
    "title": {
        "importKeywords": "Importer des mots-clés",
        "seaKeywords": "Mots-clés SEA",
        "4xxErrorIssues": "Problèmes d'erreurs 4xx",
        "accounting": "Comptabilité",
        "actions": "Actions",
        "actionsThisMonthAndYear": "Actions en {month} {year}",
        "actionsAndCpa": "Actions et CPA",
        "actionsByAge": "Actions par tranche d'âge",
        "actionsByDevice": "Actions par appareil",
        "actionsByGender": "Actions par genre",
        "activeCustomers": "Clients actifs",
        "activeCustomersWithoutAccount": "Clients actifs sans compte",
        "activeMultiAccounts": "Multi-comptes actifs",
        "actives": "Actifs",
        "adCosts": "Investissements publicitaires",
        "adCostsThisMonthAndYear": "Investissements publicitaires en {month} {year}",
        "adCostsToTurnoverRatio": "Dépenses pub % CA TTC",
        "adCostsToTurnoverRatioThisMonthAndYear": "Dépenses pub % CA TTC en {month} {year}",
        "advertisingInvestment": "Investissement publicitaire",
        "addCustomersToServer": "Ajouter des clients au serveur {name}",
        "additionalInformation": "Infos complémentaires",
        "affiliations": "Affiliation",
        "alerts": "Alertes",
        "all": "Tous",
        "allHourlyPackageAndProject": "Tous (H/F/P)",
        "answer": "Réponse",
        "apikom": "Apikom",
        "apikomContent": "Contenu Apikom",
        "apikomContents": "Contenus Apikom",
        "apikomContentThisMonthAndYear": "Contenus Apikom en {month} {year}",
        "apikomContentThisYear": "Contenus Apikom en {year}",
        "apikomObjectives": "Objectifs Apikom",
        "apikomPremium": "Premium Apikom",
        "apikomStandard": "Standard Apikom",
        "apikomTasks": "Tâches Apikom",
        "apikomTime": "Temps Apikom",
        "appointment": "RDV",
        "appointments": "Rendez-vous",
        "appointmentsShort": "RDV",
        "archived": "Archivé",
        "archivedCustomers": "Clients archivés",
        "archivedMultiAccounts": "Multi-comptes archivé",
        "audiences": "Audiences",
        "averageBasket": "Panier moyen",
        "averageBasketThisMonthAndYear": "Panier moyen en {month} {year}",
        "averageBasketWithDays": "Panier moyen des {days} derniers jours",
        "averageCustomerLifeTime": "Durée de vie moyenne du client",
        "averageDelayBetweenPurchases": "Délai moyen entre 2 commandes",
        "averageNumberOfPurchasePerYears": "Nombre moyen d'achats par an par client",
        "averagePageSpeedScoreDesktop": "Score moyen desktop",
        "averagePageSpeedScoreMobile": "Score moyen mobile",
        "averageRating": "Note moyenne",
        "averageRatingThisMonthAndYear": "Note moyenne en {month} {year}",
        "averageRefundRate": "Taux de remboursement moyen",
        "backlinkThisMonthAndYear": "Liens achetés en {month} {year}",
        "backlinkThisYear": "Liens achetés en {year}",
        "backup": "Backup",
        "banners": "Bannières",
        "bestPractices": "Bonnes pratiques",
        "budgetNotes": "Notes de budget",
        "budgets": "Budgets",
        "byDay": "Par jour",
        "byMonth": "Par mois",
        "byWeek": "Par semaine",
        "cac": "Coût d'acquisition client",
        "callbackRequests": "Demandes de rappel",
        "cart": "Panier",
        "cartConversionRate": "Taux conversion panier",
        "cartFunnel": "Entonnoir de conversion",
        "carts": "Paniers",
        "cashedExcludedTaxPerMonth": "Encaissé HT/mois",
        "categories": "Catégories",
        "category_with_less_than_x_products_in_stock": "Catégorie(s) avec une quantité insuffisante de produits disponibles",
        "categoryContents": "Contenus catégories",
        "categoryPremium": "Premium Catégorie",
        "categoryStandard": "Standard Catégorie",
        "chat": "Chat",
        "city": "Ville",
        "clicks": "Clics",
        "clicksThisMonthAndYear": "Clics en {month} {year}",
        "clicksAndCpc": "Clics et CPC",
        "clicksByAge": "Clics par tranche d'âge",
        "clicksByDevice": "Clics par appareil",
        "clicksByGender": "Clics par genre",
        "closed": "Fermé",
        "closedProjects": "Projets fermés",
        "closedTasks": "Tâches fermées",
        "comment": "Commentaire",
        "commitment": "Engagement",
        "competitorsToFollow": "Concurrents à suivre",
        "complexSupplyCreate": "Mode avancé",
        "configuration": "Configuration",
        "configurations": "Configurations",
        "configure": "Configurer",
        "contacts": "Contacts",
        "contentOptimisation": "Optimisation de contenus",
        "contentOptimisationToDo": "Optimisation de contenus à faire",
        "contents": "Contenus",
        "conversions": "Conversions",
        "conversionsThisMonthAndYear": "Conversions en {month} {year}",
        "conversionRateAfterFirstPurchase": "Taux de conversion du 1er achat en 2e achat",
        "country": "Pays",
        "cost": "Coût",
        "costExcludedTaxPerMonth": "Coût HT/mois",
        "costs": "Coûts",
        "costsThisMonthAndYear": "Coûts en {month} {year}",
        "costsAndCostsToTurnoverRatio": "Coûts et coûts % CA",
        "costsToOrderTurnoverRatio": "Dépenses % CA TTC",
        "costsToOrderTurnoverRatioThisMonthAndYear": "Dépenses % CA TTC en {month} {year}",
        "costsToTurnoverRatio": "Coûts % CA",
        "costToClicksRatio": "CPC Moyen",
        "costToTurnoverRatio": "% CA",
        "cpa": "CPA",
        "cpc": "CPC",
        "cpm": "CPM",
        "createAffiliation": "Créer une affiliation",
        "createApikomContent": "Créer un contenu Apikom",
        "createApikomTask": "Créer une tâche Apikom",
        "createApikomTaskIdea": "Créer une idée de tâche Apikom",
        "createAppointment": "Créer un rendez-vous",
        "createAudience": "Créer une audience",
        "createBacklink": "Créer un backlink",
        "createBanner": "Créer une bannière",
        "createCustomerTask": "Créer une tâche client",
        "createCustomerTaskIdea": "Créer une idée de tâche client",
        "createCustomerUser": "Créer un utilisateur pour le client {tenantName}",
        "createDevPageSpeedUrl": "Créer une URL de temps de chargement",
        "createEmailing": "Créer un emailing",
        "createEvent": "Créer un événement",
        "createFaq": "Créer une FAQ",
        "createIndexationSitemap": "Créer un sitemap d'indexation",
        "createInternalMeshLink": "Créer un lien du maillage interne",
        "createPackage": "Créer un forfait",
        "createPartner": "Créer un partenaire",
        "createProspect": "Créer un prospect",
        "createQuotation": "Créer un devis",
        "createRedirection": "Créer une redirection",
        "createRole": "Créer un rôle",
        "createSegmentation": "Créer une segmentation",
        "createSms": "Créer un SMS",
        "createTest": "Créer un test",
        "createUser": "Créer un utilisateur",
        "createUserTest": "Créer un test utilisateur",
        "createWebsiteVariant": "Créer un site",
        "cs": "CS",
        "ctr": "CTR",
        "customer": "Client",
        "customerComment": "Commentaire client",
        "customers": "Clients",
        "customerTasks": "Tâches client",
        "customerTasksReminder": "Relance tâches client",
        "customersWithReport": "Clients avec rapport",
        "customersWithoutReport": "Clients sans rapport",
        "cvr": "CVR",
        "dashboard": "Tableau de bord",
        "data": "Données",
        "datakepler": "Datakepler",
        "deleteAffiliation": "Supprimer l'affiliation #{id}",
        "deleteApikomContent": "Supprimer le contenu Apikom #{id}",
        "deleteAppointment": "Supprimer le rendez-vous #{id}",
        "deleteAudience": "Supprimer l'audience #{id}",
        "deleteBacklink": "Supprimer le backlink #{id}",
        "deleteBanner": "Supprimer la bannière #{id}",
        "deleteCallbackRequest": "Supprimer la demande de rappel #{id}",
        "deleteCustomerUser": "Supprimer l'utilisateur #{tenantUserId} du client {tenantName}",
        "deleteEmailing": "Supprimer l'emailing #{id}",
        "deleteEvent": "Supprimer l'événement #{id}",
        "deleteFaq": "Supprimer la FAQ #{id}",
        "deleteIndexationSitemap": "Supprimer le sitemap d'indexation #{id}",
        "deleteInternalMeshLink": "Supprimer le lien du maillage interne #{id}",
        "deletePageSpeedUrl": "Supprimer l'URL de temps de chargement #{id}",
        "deletePartner": "Supprimer le partenaire #{id}",
        "deleteProspect": "Supprimer le prospect #{id}",
        "deleteQuotation": "Supprimer le devis #{id}",
        "deleteRedirection": "Supprimer la redirection #{id}",
        "deleteSegmentation": "Supprimer la segmentation #{id}",
        "deleteSms": "Supprimer le SMS #{id}",
        "deleteTest": "Supprimer le test #{id}",
        "deleteTrackingKeyword": "Supprimer le mot-clé de suivi #{id}",
        "deleteUser": "Supprimer l'utilisateur #{userId}",
        "deleteUserTest": "Supprimer le test utilisateur #{id}",
        "deleteWebsiteVariant": "Supprimer le site #{variantId}",
        "description": "Description",
        "descriptionAndRequirements": "Description et besoins",
        "dev": "DEV",
        "devProjects": "Projets DEV",
        "devProjectsToTake": "Projets DEV à prendre",
        "devSeo": "DEV SEO",
        "devToTake": "DEV à prendre",
        "display": "Affichage",
        "docAndFaq": "Doc & FAQ",
        "documentation": "Documentation",
        "documents": "Documents",
        "done": "Terminé",
        "download": "Téléchargement",
        "dropbox": "Dropbox",
        "eCommerce": "E-commerce",
        "eCommerceContents": "Contenus E-commerce",
        "eCommerceModules": "Modules e-commerce",
        "editFaq": "Modifier la FAQ",
        "editLink": "Modifier un lien",
        "eighteenToTwentyFour": "18-24 ans",
        "emailing": "Emailing",
        "enableModule": "Activer un module",
        "engagementRate": "Taux d'engagement",
        "engagementRateThisMonthAndYear": "Taux d'engagement en {month} {year}",
        "erp": "ERP",
        "error": "Erreur",
        "error403": "Erreur 403",
        "error404": "Erreur 404",
        "error500": "Erreur 500",
        "error503": "Erreur 503",
        "errors": "Erreurs",
        "estimatedSaleAmount": "Total estimé des ventes",
        "event": "Événement",
        "events": "Événements",
        "externalService": "Service externe",
        "externalServices": "Services externes",
        "facebook": "Facebook",
        "facebookAds": "Facebook Ads",
        "faq": "FAQ",
        "fiftyFiveToSixtyFour": "55-64 ans",
        "followers": "Followers",
        "followersThisMonthAndYear": "Followers en {month} {year}",
        "forgotPassword": "Mot de passe oublié",
        "forthcoming": "À venir",
        "forthcomingAppointment": "RDV à venir",
        "fortyFiveToFiftyFour": "45-54 ans",
        "frequency": "Répétition",
        "general": "Général",
        "geo": "GEO",
        "global": "Global",
        "google": "Google",
        "googleAds": "Google Ads",
        "googleAdsSearch": "Google Ads Search",
        "googleAnalytics": "Google Analytics",
        "googleMerchant": "Google Merchant",
        "googleMyBusiness": "Google My Business",
        "googleMyBusinessAverageRating": "Note moyenne Google My Business",
        "googleMyBusinessTotalRating": "Total Avis Google My Business",
        "googleMyBusinessTotalRatingLast30Days": "Nouveau(x) Avis Google My Business J-30",
        "googleSearchConsole": "Google Search Console",
        "grossLtv": "LTV brute",
        "grossMargin": "Marge brute",
        "grossMarginExclTax": "Marge brute HT",
        "grossMarginExcludingTax": "Marge brute HT",
        "grossMarginExcludingTaxToTurnoverRatio": "Marge brute HT % CA",
        "grossMarginToTurnoverRatio": "Marge brute HT % CA",
        "grossRoas": "ROAS brut",
        "groups": "Groupes",
        "guaranteedReviewsCompany": "Société des Avis Garantis",
        "guaranteedReviewsWebsiteAverageRating": "Note moyenne Avis Garantis",
        "guaranteedReviewsWebsiteTotalRating": "Total Avis Garantis",
        "guaranteedReviewsWebsiteTotalRatingLast30Days": "Nouveau(x) Avis Garantis J-30",
        "help": "Aide",
        "highPerformanceKeywords": "Mots-clés performants",
        "history": "Historique",
        "host": "Hôte",
        "hourlyValidatedTime": "Temps H",
        "idea": "Idée",
        "ideas": "Idées",
        "import": "Importer",
        "importBacklinks": "Importer des backlinks",
        "impressions": "Impressions",
        "impressionsAndCpm": "Impressions et CPM",
        "impressionsByAge": "Impressions par tranche d'âge",
        "impressionsByDevice": "Impressions par appareil",
        "impressionsByGender": "Impressions par genre",
        "in_stock_but_disabled": "En stock mais désactivé(s)",
        "indexation": "Indexation",
        "indexationData": "Données d'indexation",
        "indexationRequest": "Demande d'indexation",
        "indexed": "Indexé",
        "indexedUrl": "URL indexé",
        "indexedPages": "Pages indexées",
        "information": "Informations",
        "instagram": "Instagram",
        "internalComment": "Commentaire interne",
        "internalMesh": "Maillage interne",
        "internalMeshLinkThisMonthAndYear": "Pages optimisées en maillage interne en {month} {year}",
        "internalMeshLinkThisYear": "Pages optimisées en maillage interne en {year}",
        "internalNetworking": "Maillage interne",
        "internalNetworkingToDo": "Maillage interne à faire",
        "internalNotes": "Notes internes",
        "invoiced": "Facturé",
        "invoicedTotalTime": "Temps total facturé",
        "invoices": "Factures",
        "invoicing": "Facturation",
        "ipBlock": "Bloc IP",
        "ipBlockCostExcludedTaxPerMonth": "Coût bloc IP HT/mois",
        "ips": "IPs",
        "keywords": "Mots-clés",
        "keywordsDistributed": "Mots-clés diffusés",
        "keywordsInsights": "Mots-clés insights",
        "keywordsPurchased": "Mots-clés achetés",
        "keywordsToWatch": "Mots-clés à surveiller",
        "language": "Langue",
        "latestMinimumSupportedVersion": "Dernière version minimale supportée",
        "latestVersion": "Dernière version",
        "lifeTimeValues": "LTV",
        "listOfKeywordsTracked": "Liste des mots-clés suivis",
        "ltvOverLast3Months": "LTV sur les 3 derniers mois",
        "login": "Connexion",
        "logout": "Déconnexion",
        "lost": "Perdu",
        "magento1": "Magento 1",
        "magento2": "Magento 2",
        "mailjet": "Mailjet",
        "maintenanceCostExcludedTaxPerMonth": "Coût maintenance HT/mois",
        "makeAnAppointment": "Prendre RDV",
        "marginRate": "Taux de marge",
        "message": "Message",
        "meta": "Méta",
        "metaAds": "Meta Ads",
        "minimalTargetRoas": "ROAS cible minimum",
        "modificationHistory": "Historique des modifications",
        "modules": "Modules",
        "myTasks": "Mes tâches",
        "myTasksWithCount": "Mes tâches ({count})",
        "netlinking": "Netlinking",
        "netlinkingToDo": "Netlinking à faire",
        "netLtv": "LTV nette",
        "netMarginExclTax": "Marge nette HT",
        "netMarginExcludingTax": "Marge nette HT",
        "netMarginExcludingTaxToTurnoverRatio": "Marge nette HT % CA",
        "netMarginToTurnoverRatio": "Marge nette HT % CA",
        "netRoas": "ROAS net",
        "new": "Nouveau",
        "newUsers": "Nouveaux utilisateurs",
        "newUsersThisMonthAndYear": "Nouveaux utilisateurs en {month} {year}",
        "nonIndexedUrls": "URLs non indexées",
        "noProfitable": "Non rentable",
        "notIndexed": "Non indexé",
        "notIndexedUrl": "URL non indexé",
        "notes": "Notes",
        "novelties": "Nouveautés",
        "numberOfFacebookFollowers": "Followers Facebook",
        "numberOfFollowers": "Nombre de followers",
        "numberOfInstagramFollowers": "Followers Instagram",
        "numberOfInstagramFollowersThisMonthAndYear": "Followers Instagram en {month} {year}",
        "numberOfInvoices": "Nb factures",
        "numberOfNewFacebookFollowersLast30Days": "Nouveaux followers Facebook J-30",
        "numberOfNewFollowers": "Nouveaux followers",
        "numberOfNewFollowersThisMonthAndYear": "Nouveaux followers en {month} {year}",
        "numberOfNewInstagramFollowersLast30Days": "Nouveaux followers Instagram J-30",
        "numberOfOrders": "Nb commandes",
        "numberOfRefunds": "Nb remboursements",
        "numberOfShipments": "Nb expéditions",
        "objectives": "Objectifs",
        "ongoing": "En cours",
        "ongoingProjects": "Projets en cours",
        "open": "Ouvert",
        "openAndToProcess": "Ouvert/À traiter",
        "openToProcessAndProcessed": "Ouvert/À traiter/Traitée",
        "opportunities": "Opportunités",
        "orderCount": "Nombre de commandes",
        "orderCountThisMonthAndYear": "Nombre de commandes en {month} {year}",
        "orders": "Commandes",
        "ordersThisMonthAndYear": "Commandes en {month} {year}",
        "otherPremium": "Premium Autre",
        "otherProjects": "Projets autres",
        "others": "Autres",
        "otherStandard": "Standard Autre",
        "out_of_stock_but_with_quantity": "En statut épuisé mais avec un stock supérieur à 0",
        "packages": "Forfaits",
        "packageTime": "Temps F",
        "page": "Page",
        "pages": "Pages",
        "pageSpeed": "Temps de chargement",
        "paid": "Payé",
        "partiallyInvoiced": "Partiellement facturé",
        "partner": "Partenaire",
        "partners": "Partenaires",
        "password": "Mot de passe",
        "payment": "Paiement",
        "pending": "En attente",
        "pendingInternalMeshLink": "Pages en attente de validation",
        "perCustomer": "Par client",
        "perCustomerObjective": "Par client (objectif)",
        "permanentRedirectIssues": "Problèmes de redirection permanente",
        "permissions": "Permissions",
        "perMonthDone": "Terminé/mois",
        "perMonthOngoing": "En cours/mois",
        "perQuarterDone": "Terminé/trimestre",
        "perQuarterOngoing": "En cours/trimestre",
        "phpVersions": "Versions PHP",
        "positionedKeywords": "Mots-clés positionnés",
        "positionHistory": "Historique de positions",
        "positions": "Positions",
        "positionTracking": "Suivi de positions",
        "premium": "Premium",
        "premiumContentCountThisMonthAndYear": "Contenus premium en {month} {year}",
        "premiumContentCountThisYear": "Contenus premium en {year}",
        "prestashop": "Prestashop",
        "preview": "Aperçu",
        "printNode": "PrintNode",
        "privacyPolicy": "Politique de confidentialité",
        "privacyPolicyNotAccepted": "Politique de confidentialité non acceptée",
        "processed": "Traité",
        "productContents": "Contenus produits",
        "productCostSumExclTax": "Total coûts produits HT",
        "productPremium": "Premium Produit",
        "products": "Produits",
        "productsCost": "Coûts produits",
        "productStandard": "Standard Produit",
        "productsTurnoverExcludingTax": "CA Produits HT",
        "productsTurnoverExcludingTaxInvoiced": "CA Produits HT facturé",
        "productsTurnoverIncludingTax": "CA Produits TTC",
        "productsTurnoverIncludingTaxInvoiced": "CA Produits TTC facturé",
        "productTurnoverSumExclTax": "Total produits HT",
        "profile": "Profil",
        "profitable": "Rentable",
        "projectManagement": "Gestion de projet",
        "projects": "Projets",
        "projectTime": "Temps P",
        "projectToTake": "Projet à prendre",
        "prospects": "Prospects",
        "quotation": "Devis",
        "quotations": "Devis",
        "reach": "Converture",
        "reachAndFrequency": "Couverture et répétition",
        "realTodayTime": "Temps du jour réel",
        "realTotalTime": "Temps total réel",
        "recalled": "Rappelés",
        "recap": "Récap",
        "redirections": "Redirections",
        "refreshData": "Actualiser les données",
        "refreshECommerceData": "Actualiser les données e-commerce : {type}",
        "refundCount": "Nombre de remboursements",
        "refundCountThisMonthAndYear": "Nombre de remboursements en {month} {year}",
        "refunds": "Total remboursements",
        "refundsThisMonthAndYear": "Remboursements en {month} {year}",
        "refundsToTurnoverRatio": "Remboursements % CA",
        "refundsToTurnoverRatioThisMonthAndYear": "Remboursements % CA en {month} {year}",
        "refundSumExclTax": "Total remboursements HT",
        "report": "Rapport",
        "reports": "Rapports",
        "reportWithMonth": "Rapport {month}",
        "reportWithMonthAndYear": "Rapport du mois de {month} {year}",
        "requestCallback": "Demande de rappel",
        "requirements": "Besoins",
        "resetPassword": "Réinitialiser le mot de passe",
        "returnOnAdSpend": "ROAS",
        "review": "Avis",
        "reviews": "Avis",
        "reviewsOfMonth": "Avis du mois de {month}",
        "roas": "ROAS",
        "roasThisMonthAndYear": "ROAS en {month} {year}",
        "roles": "Rôles",
        "sea": "SEA",
        "seaCosts": "Coûts SEA",
        "seaOfMonth": "SEA du mois de {month}",
        "seaAndSmaCost": "Investissement publicitaire",
        "seaAndSmaCostToTurnoverRatio": "Dépenses pub % CA TTC",
        "seaCost": "Coût SEA",
        "seaCostsToTurnoverRatio": "SEA % CA TTC",
        "seaCostToTurnoverRatio": "SEA % CA TTC",
        "search": "Recherche",
        "searchAnalysis": "Analyse de recherche",
        "seaReturnOnAdSpend": "SEA ROAS",
        "seaRoas": "SEA ROAS",
        "security": "Sécurité",
        "segmentationCustomers": "Segmentation #{id} des clients",
        "segmentations": "Segmentations",
        "selectFolder": "Sélectionner un dossier",
        "sem": "SEM",
        "semrush": "Semrush",
        "sendEmail": "Envoyer un email",
        "sendLastReport": "Envoyer le dernier rapport",
        "seo": "SEO",
        "seoDev": "SEO DEV",
        "seoErrors": "Erreurs SEO",
        "seoToDo": "SEO à faire",
        "serverAdminLimitedByIp": "Virtualmin limité par IP",
        "serverAndSecurity": "Sécurité",
        "serverCostExcludedTaxPerMonth": "Coût serveur HT/mois",
        "serverName": "Nom du serveur",
        "servers": "Serveurs",
        "services": "Prestations",
        "sessionsAndSessionsPerUser": "Sessions et nombre de sessions par utilisateur",
        "sessionsAndSessionsPerUserThisMonthAndYear": "Sessions et nombre de sessions par utilisateur en {month} {year}",
        "sessions": "Sessions",
        "sessionsThisMonthAndYear": "Sessions en {month} {year}",
        "sessionsPerUser": "Nombre de sessions par utilisateur",
        "sessionsPerUserThisMonthAndYear": "Nombre de sessions par utilisateur en {month} {year}",
        "settings": "Paramètres",
        "sharedNotes": "Notes partagées",
        "shipments": "Expéditions",
        "shipping": "Livraison",
        "shippingSumExclTax": "Total frais de port HT",
        "shippingTurnoverExcludingTax": "CA Livraison HT",
        "shippingTurnoverExcludingTaxInvoiced": "CA Livraison HT facturé",
        "shippingTurnoverIncludingTax": "CA Livraison TTC",
        "shippingTurnoverIncludingTaxInvoiced": "CA Livraison TTC facturé",
        "shop": "Boutique",
        "shortDescription": "Description courte",
        "showcase": "Vitrine",
        "simpleSupplyCreate": "Mode simple",
        "sitemapList": "Liste des sitemaps",
        "sitemap": "Sitemap",
        "sitemaps": "Sitemaps",
        "sixtyFiveAndOver": "65 ans et +",
        "sku": "SKU",
        "sma": "SMA",
        "smaCosts": "Coûts SMA",
        "smaOfMonth": "SMA du mois de {month}",
        "smaAndSeaCost": "Investissement publicitaire",
        "smaAndSeaReturnOnAdSpend": "SMA & SEA ROAS",
        "smaCost": "Coût SMA",
        "smaCostsToTurnoverRatio": "SMA % CA TTC",
        "smaCostToTurnoverRatio": "SMA % CA TTC",
        "smaReturnOnAdSpend": "SMA ROAS",
        "smaRoas": "SMA ROAS",
        "smo": "SMO",
        "smoOfMonth": "SMO du mois de {month}",
        "sms": "SMS",
        "socialMedia": "Médias sociaux",
        "sshLimitedByIp": "SSH limité par IP",
        "sshProtectedByKey": "SSH protégé par clé",
        "standard": "Standard",
        "standardContentCountThisMonthAndYear": "Contenus standard en {month} {year}",
        "standardContentCountThisYear": "Contenus standard en {year}",
        "statistics": "Statistiques",
        "storageSpace": "Espace de stockage",
        "storeAndEcommerce": "Boutique et E-commerce",
        "strategy": "Stratégie",
        "strategyAndObjectives": "Stratégie et objectifs",
        "subTasks": "Sous-tâches",
        "summary": "Résumé",
        "sumTotalIncludingTax": "Total TTC",
        "sumTotalIncludingTaxCart": "Total TTC panier",
        "superAdmin": "Super Admin",
        "targets": "Cibles",
        "tasks": "Tâches",
        "tasksReminder": "Relance tâches",
        "technicalOptimisation": "Optimisation technique",
        "technicalOptimisationToDo": "Optimisation technique à faire",
        "test": "Test",
        "tests": "Tests",
        "thirtyFiveToFortyFour": "35-44 ans",
        "time": "Temps",
        "toInvoice": "À facturer",
        "toProcess": "À traiter",
        "topTrackedKeywordCount": "Mots-clés suivis (TOP {top})",
        "topTrackedKeywordCountLast30Days": "Mots-clés suivis J-30 (TOP {top})",
        "toRemind": "À rappeler",
        "totalAvailableQuantity": "Quantité disponible totale",
        "totalCloudflareCostExcludedTaxPerMonth": "Coût Cloudflare HT/mois",
        "totalCost": "Coût total",
        "totalCostExcludedTaxPerMonth": "Coût total HT/mois",
        "totalExcludingTax": "Total HT",
        "totalIncludingTax": "Total TTC",
        "totalIncludingTaxCart": "Total TTC panier",
        "totalNet": "Total net",
        "totalNumber": "Chiffres",
        "totalNumberOfMonth": "Chiffres du mois de {month}",
        "totalPricePerMonth": "Prix total/mois",
        "totalQuantity": "Quantité totale",
        "totalQuantityRefunded": "Quantité remboursée totale",
        "totalQuantitySold": "Quantité vendue totale",
        "totalRating": "Total avis",
        "totalRatingThisMonthAndYear": "Total avis en {month} {year}",
        "totalRefundsIncludingTax": "Total remboursements net",
        "totals": "Totaux",
        "totalQtyRefunded": "Qté totale remboursée",
        "totalTurnover": "CA total",
        "totalUsers": "Nombre total utilisateurs",
        "totalUsersThisMonthAndYear": "Nombre total utilisateurs en {month} {year}",
        "totalUsersAndNewUsers": "Nombre total utilisateurs et nouveaux utilisateurs",
        "totalUsersAndNewUsersThisMonthAndYear": "Nombre total utilisateurs et nouveaux utilisateurs en {month} {year}",
        "toValidate": "À valider",
        "toValidateDev": "À valider H",
        "toValidateHourlyPackageAndProject": "À valider (H/F/P)",
        "toWatch": "À surveiller",
        "trackedKeywordCount": "Mots-clés suivis",
        "trackedKeywordCountLast30Days": "Mots-clés suivis J-30",
        "trackingPositions": "Suivi de positions",
        "turnover": "CA TTC",
        "turnoverExclTax": "CA HT",
        "turnoverExclTaxWithoutShipping": "CA HT hors frais de port",
        "turnoverExcludingTax": "CA HT",
        "turnoverExcludingTaxAndExcludingShippingCosts": "CA HT hors frais de port",
        "turnoverExcludingTaxAndExcludingShippingCostsThisMonthAndYear": "CA HT hors frais de port en {month} {year}",
        "turnoverExcludingTaxInvoiced": "CA HT facturé",
        "turnoverExcludingTaxThisMonthAndYear": "CA HT en {month} {year}",
        "turnoverIncludingTax": "CA TTC",
        "turnoverIncludingTaxAndExcludingShippingCosts": "CA TTC hors frais de port",
        "turnoverIncludingTaxAndExcludingShippingCostsThisMonthAndYear": "CA TTC hors frais de port en {month} {year}",
        "turnoverIncludingTaxInvoiced": "CA TTC facturé",
        "turnoverIncludingTaxThisMonthAndYear": "CA TTC en {month} {year}",
        "turnoverWithoutShipping": "CA TTC hors frais de port",
        "twentyFiveToThirtyFour": "25-34 ans",
        "untrackedTasks": "Tâches non traitées",
        "update": "Mettre à jour",
        "updateAffiliation": "Mettre à jour l'affiliation #{id}",
        "updateApikomContent": "Mettre à jour le contenu Apikom #{id}",
        "updateApikomTask": "Mettre à jour la tâche Apikom #{id}",
        "updateApikomTaskIdea": "Mettre à jour une idée de tâche Apikom #{id}",
        "updateAppointment": "Mettre à jour le rendez-vous #{id}",
        "updateAppointmentFrequency": "Mettre à jour la fréquence des RDV du client {tenantName}",
        "updateAudience": "Mettre à jour l'audience #{id}",
        "updateBacklink": "Mettre à jour le backlink #{id}",
        "updateBanner": "Mettre à jour la bannière #{id}",
        "updateCustomerTask": "Mettre à jour la tâche client #{id}",
        "updateCustomerTaskIdea": "Mettre à jour l'idée de tâche client #{id}",
        "updateCustomerUser": "Mettre à jour l'utilisateur #{tenantUserId} du client {tenantName}",
        "updateECommerceModules": "Mettre à jour les modules e-commerce #{id}",
        "updateFaq": "Mettre à jour la FAQ #{id}",
        "updateEmailing": "Mettre à jour l'emailing #{id}",
        "updateEvent": "Mettre à jour l'événement #{id}",
        "updateIndexationSitemap": "Mettre à jour le sitemap d'indexation #{id}",
        "updateInternalMeshLink": "Metre à jour le lien du maillage interne #{id}",
        "updateLatestMagento1MinimumSupportedVersion": "Mettre à jour la dernière version minimale supportée de Magento 1",
        "updateLatestMagento1Version": "Mettre à jour la dernière version de Magento 1",
        "updateLatestMagento2MinimumSupportedVersion": "Mettre à jour la dernière version minimale supportée de Magento 2",
        "updateLatestMagento2Version": "Mettre à jour la dernière version de Magento 2",
        "updateLatestPrestashopMinimumSupportedVersion": "Mettre à jour la dernière version minimale supportée de Prestashop",
        "updateLatestPrestashopVersion": "Mettre à jour la dernière version de Prestashop",
        "updateModule": "Mettre à jour le module #{key}",
        "updatePackage": "Mettre à jour le forfait #{id}",
        "updatePartner": "Mettre à jour le partenaire #{id}",
        "updateProspect": "Mettre à jour le prospect #{id}",
        "updateQuotation": "Mettre à jour le devis #{id}",
        "updateRedirection": "Mettre à jour la redirection #{id}",
        "updateRole": "Mettre à jour le rôle #{roleId}",
        "updateSegmentation": "Mettre à jour la segmentation #{id}",
        "updateServer": "Mettre à jour le serveur {name}",
        "updateSms": "Mettre à jour le SMS #{id}",
        "updateTest": "Mettre à jour le test #{id}",
        "updateUser": "Mettre à jour l'utilisateur #{id}",
        "updateUserTest": "Mettre à jour le test utilisateur #{id}",
        "updateWebsite": "Mettre à jour le site Web #{id}",
        "updateWebsiteVariant": "Mettre à jour le site #{variantId}",
        "url": "URL",
        "urls": "URLs",
        "username": "Nom d'utilisateur",
        "users": "Utilisateurs",
        "userTests": "Tests utilisateur",
        "validated": "Validé",
        "verifiedReviews": "Avis Vérifiés",
        "verifiedReviewsWebsiteAverageRating": "Note moyenne Avis Vérifiés",
        "verifiedReviewsWebsiteTotalRating": "Total Avis Vérifiés",
        "verifiedReviewsWebsiteTotalRatingLast30Days": "Nouveau(x) Avis Vérifiés J-30",
        "website": "Site Web",
        "websiteAndPerformance": "Modules et Performance",
        "websites": "Sites Web",
        "websiteVariants": "Sites",
        "withoutDescription": "Sans description",
        "withoutMetaDescription": "Sans méta-description",
        "withoutMetaTitle": "Sans méta-titre",
        "withoutShortDescription": "Sans description courte",
        "won": "Gagné"
    },
    "toast": {
        "anErrorOccurred": "Une erreur est survenue.",
        "credentialsNotMatch": "Les identifiants sont incorrects.",
        "passwordResetLinkSent": "Un lien de réinitialisation de mot de passe a été envoyé à l'adresse email {email}.",
        "passwordResetLinkThrottled": "Un email de réinitialisation de mot de passe a déjà été envoyé. Veuillez vérifier votre boîte de réception.",
        "passwordResetLinkUserNotFound": "Aucun utilisateur n'a été trouvé avec cette adresse email.",
        "passwordResetSuccess": "Votre mot de passe a été réinitialisé avec succès.",
        "refreshingDataInBackground": "Actualisation des données en arrière-plan.",
        "successfullyAdded": "Ajouté avec succès.",
        "successfullyDeleted": "Supprimé avec succès.",
        "successfullyEnabled": "Activé avec succès.",
        "successfullyImported": "Importé avec succès.",
        "successfullySaved": "Enregistré avec succès.",
        "successfullySent": "Envoyé avec succès."
    }
};
